namespace RioERP.Users {
    export interface TeachersRow {
        Id?: number;
        Name?: string;
        Description?: string;
        Email?: string;
        AlternateEmail?: string;
        Mobile?: string;
        AlternateMobile?: string;
        Address?: string;
        City?: string;
        StateId?: number;
        UserId?: number;
        Gstin?: string;
        Pan?: string;
        GstCertificate?: string;
        BankName?: string;
        BankAccountType?: Web.Enums.BankAccountType;
        BankAccountName?: string;
        BankAccountNo?: string;
        BankIfscCode?: string;
        Pincode?: number;
        IsActive?: boolean;
        IsGstApplicable?: boolean;
        StateName?: string;
        StateIsActive?: boolean;
        StateInsertUserId?: number;
        StateInsertDate?: string;
        StateUpdateUserId?: number;
        StateUpdateDate?: string;
        StateIsHomeState?: boolean;
        UserUsername?: string;
        UserDisplayName?: string;
        UserEmail?: string;
        UserSource?: string;
        UserLastDirectoryUpdate?: string;
        UserUserImage?: string;
        UserInsertDate?: string;
        UserInsertUserId?: number;
        UserUpdateDate?: string;
        UserUpdateUserId?: number;
        UserIsActive?: number;
        UserMobilePhoneNumber?: string;
        UserMobilePhoneVerified?: boolean;
        UserTwoFactorAuth?: number;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace TeachersRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Users.Teachers';
        export const lookupKey = 'Users.Teachers';

        export function getLookup(): Q.Lookup<TeachersRow> {
            return Q.getLookup<TeachersRow>('Users.Teachers');
        }
        export const deletePermission = 'Users:UsersManagement:Modify';
        export const insertPermission = 'Users:UsersManagement:Modify';
        export const readPermission = 'Users:UsersManagement:View';
        export const updatePermission = 'Users:UsersManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name",
            Description = "Description",
            Email = "Email",
            AlternateEmail = "AlternateEmail",
            Mobile = "Mobile",
            AlternateMobile = "AlternateMobile",
            Address = "Address",
            City = "City",
            StateId = "StateId",
            UserId = "UserId",
            Gstin = "Gstin",
            Pan = "Pan",
            GstCertificate = "GstCertificate",
            BankName = "BankName",
            BankAccountType = "BankAccountType",
            BankAccountName = "BankAccountName",
            BankAccountNo = "BankAccountNo",
            BankIfscCode = "BankIfscCode",
            Pincode = "Pincode",
            IsActive = "IsActive",
            IsGstApplicable = "IsGstApplicable",
            StateName = "StateName",
            StateIsActive = "StateIsActive",
            StateInsertUserId = "StateInsertUserId",
            StateInsertDate = "StateInsertDate",
            StateUpdateUserId = "StateUpdateUserId",
            StateUpdateDate = "StateUpdateDate",
            StateIsHomeState = "StateIsHomeState",
            UserUsername = "UserUsername",
            UserDisplayName = "UserDisplayName",
            UserEmail = "UserEmail",
            UserSource = "UserSource",
            UserLastDirectoryUpdate = "UserLastDirectoryUpdate",
            UserUserImage = "UserUserImage",
            UserInsertDate = "UserInsertDate",
            UserInsertUserId = "UserInsertUserId",
            UserUpdateDate = "UserUpdateDate",
            UserUpdateUserId = "UserUpdateUserId",
            UserIsActive = "UserIsActive",
            UserMobilePhoneNumber = "UserMobilePhoneNumber",
            UserMobilePhoneVerified = "UserMobilePhoneVerified",
            UserTwoFactorAuth = "UserTwoFactorAuth",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
